<script setup lang="ts">
import type { SiteSectionsTreeSectionCategoryFilterVariant } from "@/app/tools/new-section-management/site-sections-tree/filters/section-category-filter/site-sections-tree-section-category-filter.types";

import { cn } from "@voltalis/frontend-utils";

import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";

const props = withDefaults(
  defineProps<{
    label: string;
    variant?: SiteSectionsTreeSectionCategoryFilterVariant;
    isSelected: boolean;
    selectedCount?: number;
    showSelectedCount?: boolean;
  }>(),
  {
    variant: "default",
    selectedCount: 0,
    showSelectedCount: false,
  },
);
</script>

<template>
  <span
    :class="
      cn('flex min-w-0 flex-1 items-center gap-1 truncate text-sm font-normal leading-normal text-text-secondary', {
        'text-brand font-semibold': props.isSelected,
        'font-semibold text-surface-inverse': props.variant === 'inverse-pill',
      })
    "
    :data-test-id="DATA_TEST_IDS.components.siteSectionsTreeSectionCategoryFilter.triggerLabel"
  >
    <i
      v-if="props.variant === 'inverse-pill'"
      class="pi pi-tag shrink-0 !text-[16px]"
    />
    <span class="truncate">
      {{ props.label }}
    </span>
    <span
      v-if="props.showSelectedCount && props.isSelected"
      class="shrink-0 font-semibold"
      >({{ props.selectedCount }})</span
    >
  </span>
</template>
